//-- Breakpoints
export const BREAKPOINT = {
  mobile: 0,
  tablet: 640,
  desktop: 1024,
  wide: 1440
};

//-- Keycodes
export const KEYCODES = {
  tab: 9
}




// WEBPACK FOOTER //
// ./src/cc/js/constants/index.js